var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.loaded
    ? _c("w-scroll-view", { attrs: { tag: "w-container" } }, [
        _c("div", { staticClass: "roadmap-item" }, [
          _c("h2", [_vm._v(_vm._s(_vm.roadmap.Title))]),
          _c("p", {
            staticClass: "intro",
            domProps: { innerHTML: _vm._s(_vm.roadmap.Intro) },
          }),
          _c("p", {
            staticClass: "content",
            domProps: { innerHTML: _vm._s(_vm.roadmap.Text) },
          }),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }